module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAACCAYAAABR7VzxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABISURBVHgBVYpRDoAwCENbBufw/qfSxH8PsGFwjvAxQtPXpmzPfZrrYR1Ul7BO2hCot+TyvxvEll+5BOsiDUyRRVPBfVMciPkfVnYe0THhoTUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/little-bar-b.png
// module id = FYmn
// module chunks = 1